module.exports = __webpack_public_path__ + "static/img/15areaB_4.b360598.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/15areaB_4.png
// module id = 1126
// module chunks = 1